import { render, staticRenderFns } from "./AccountSecurity.vue?vue&type=template&id=6222dee4"
import script from "./AccountSecurity.vue?vue&type=script&lang=js"
export * from "./AccountSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports